import type { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { browserBroadcastToken } from 'src/conf/di/angularProviderMapper';
import { isProbablyTouchDevice } from '@shared/models/crossDeviceCapability';
import { TrackerService } from '@shared/services/tracker.service';
import { TranslateModule } from '@ngx-translate/core';
import { OUTCOME_AUTO_CLOSE_DELAY_IN_MS } from '../connection-to-external-bank-ok/connection-to-external-bank-ok.component';

/* Same exit as the success page: closes on its own after a short delay; a button on computers only. */
@Component({
  selector: 'app-connection-to-external-bank-ko',
  templateUrl: './connection-to-external-bank-ko.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class ConnectionToExternalBankKoComponent implements OnInit, OnDestroy {
  @Input() displayCrossDeviceCopy = false;

  readonly displayCloseButton = !isProbablyTouchDevice();

  private autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private tracker: TrackerService,
    @Inject(browserBroadcastToken) private broadcastService: BrowserBroadcast
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'CONNECTION_EXTERNAL_BANK_KO' });
    this.autoCloseTimer = setTimeout(() => this.close(), OUTCOME_AUTO_CLOSE_DELAY_IN_MS);
  }

  ngOnDestroy(): void {
    if (this.autoCloseTimer !== null) {
      clearTimeout(this.autoCloseTimer);
    }
  }

  /* The user asked for it: worth a click event, unlike the automatic close. */
  closeTab(): void {
    this.tracker.trackClick({
      taggingPage: 'CONNECTION_EXTERNAL_BANK_KO',
      click: frenchi18n.close_tab,
    });

    this.close();
  }

  private close(): void {
    this.broadcastService.publish({ label: 'CLOSE_WEBAUTH_POPUP', data: null });
    window.close();
  }
}
